import React from 'react';
import { Box } from '@mui/material';
import { permissionService } from '../../services/permissionService';
import { RoleType } from '../../models/enums/roleType';
import { DispatcherHome } from './DispatcherHome';
import { MedicHome } from './MedicHome';
import { HomeHeader } from './HomeHeader';

export const Home: React.FC = () => {
    const roles = permissionService.getRoles();
    const isMedic = roles.includes(RoleType.Medic);
    const isDispatcher = roles.includes(RoleType.Dispatcher);

    return (
        <Box sx={{ p: 3 }}>
            <HomeHeader />

            {/* Если пользователь медик, показываем компонент для медика */}
            {isMedic && <MedicHome />}

            {/* Если пользователь диспетчер, показываем компонент для диспетчера */}
            {!isMedic && isDispatcher && <DispatcherHome />}

            {/* Для админа и других ролей показываем только HomeHeader */}
        </Box>
    );
};

